'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult from "./presto.types$-Freemium-Seed-Result.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FreemiumSeedResult$() {
}
export { $c_Lpresto_types$FreemiumSeedResult$ as $c_Lpresto_types$FreemiumSeedResult$ };
$p = $c_Lpresto_types$FreemiumSeedResult$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FreemiumSeedResult$;
/** @constructor */
function $h_Lpresto_types$FreemiumSeedResult$() {
}
export { $h_Lpresto_types$FreemiumSeedResult$ as $h_Lpresto_types$FreemiumSeedResult$ };
$h_Lpresto_types$FreemiumSeedResult$.prototype = $p;
$p.l = (function() {
  return "FreemiumSeedResult";
});
$p.cFW = (function(x$0) {
  return new $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult.$c_Lpresto_types$FreemiumSeedResult(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$FreemiumSeedResult$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FreemiumSeedResult$, "presto.types$FreemiumSeedResult$", ({
  a0t: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$FreemiumSeedResult$ as $d_Lpresto_types$FreemiumSeedResult$ };
var $n_Lpresto_types$FreemiumSeedResult$;
function $m_Lpresto_types$FreemiumSeedResult$() {
  if ((!$n_Lpresto_types$FreemiumSeedResult$)) {
    $n_Lpresto_types$FreemiumSeedResult$ = new $c_Lpresto_types$FreemiumSeedResult$();
  }
  return $n_Lpresto_types$FreemiumSeedResult$;
}
export { $m_Lpresto_types$FreemiumSeedResult$ as $m_Lpresto_types$FreemiumSeedResult$ };
//# sourceMappingURL=presto.types$-Freemium-Seed-Result$.js.map
